<template>
  <div class="tabList">
		<tabItem @select='selectTab'  v-for='item in list' :itemData='item' :value='value' />
  </div>
</template>

<script>
import tabItem from './tabItem'

export default {
  data () {
    return {
    }
  },
	components:{
		tabItem
	},
	props: {
		//标题
    title: {
      type: String,
      default: '默认标题',
    },
		list: {
			type: Array,
			required: true
		},
		value: {
			type: Number,
			default: 0
		}
  },
	methods: {
		selectTab(val){
			this.$emit('tabChange',val)
		}
	},
	computed: {
	}
}
</script>

<style lang="less" scoped>
	@import "../../assets/theme.less";
	.tabList{
		display:flex;
		background-color:#fff;
	}
</style>


// WEBPACK FOOTER //
// tabList.vue?51105a34